var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniGraphIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C6.47339 0 6.85714 0.373096 6.85714 0.833333V14.1667C6.85714 14.6269 6.47339 15 6 15C5.52661 15 5.14286 14.6269 5.14286 14.1667V0.833333C5.14286 0.373096 5.52661 0 6 0ZM11.1429 5C11.6162 5 12 5.3731 12 5.83333V14.1667C12 14.6269 11.6162 15 11.1429 15C10.6695 15 10.2857 14.6269 10.2857 14.1667V5.83333C10.2857 5.3731 10.6695 5 11.1429 5ZM0.857143 8.33333C1.33053 8.33333 1.71429 8.70643 1.71429 9.16667V14.1667C1.71429 14.6269 1.33053 15 0.857143 15C0.383756 15 0 14.6269 0 14.1667V9.16667C0 8.70643 0.383756 8.33333 0.857143 8.33333Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniGraphIcon);
export default __webpack_public_path__ + "static/media/mini-graph-icon.cc9ce8fa850802d1f2e582283f17cba9.svg";
export { ForwardRef as ReactComponent };